import { LandingContext } from 'common/contexts/Landing/Landing'
import { usePageTracking } from 'common/hooks'
import { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Banquet, Landing, Layout } from 'views'

export const AllRoutes = () => {
  const { landing } = useContext(LandingContext)
  usePageTracking()
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Landing />} />
        {landing?.banketEnabled && (
          <Route path="banquet" element={<Banquet />} />
        )}
      </Route>
    </Routes>
  )
}
